import React from 'react';
import { MicroSession } from '@/data/microSessions';
import { Flame } from 'lucide-react';
import { microToneFramework } from '@/content/microToneFramework';

interface MicroDashboardHeroProps {
  session: MicroSession | null;
  stats: {
    headline?: string;
    tip?: string;
  };
  motivation?: {
    headline: string;
    body: string;
  };
}

export const MicroDashboardHero: React.FC<MicroDashboardHeroProps> = ({
  session,
  stats,
  motivation
}) => {
  if (!session) return null;

  const heroHeadline =
    motivation?.headline ||
    stats.headline ||
    microToneFramework.starterPhrases.heroTagline;

  const mainBlurb =
    motivation?.body ||
    stats.tip ||
    microToneFramework.starterPhrases.guidanceHeader;

  return (
    <div className="relative overflow-hidden rounded-[36px] border border-slate-200 bg-slate-100 text-slate-900 shadow-xl">
      <div className="absolute inset-0 opacity-40 pointer-events-none" aria-hidden="true">
        <div className="absolute -top-8 right-6 h-40 w-40 rounded-full bg-slate-100 blur-[90px]" />
        <div className="absolute bottom-0 left-10 h-28 w-28 rounded-full bg-slate-50 blur-[100px]" />
      </div>
      <div className="relative p-6 md:p-10 flex flex-col gap-6">
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-slate-400">
          <Flame className="w-4 h-4 text-slate-500" />
          Today with Lyra
        </div>
        <div className="space-y-3">
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">
            {heroHeadline}
          </h1>
          <p className="text-base text-slate-600 max-w-2xl">
            {mainBlurb}
          </p>
        </div>
      </div>
    </div>
  );
};
